import { Unit } from 'uom';
import { DropdownField } from 'src/modules/common/components/DropdownField/DropdownField.tsx';
import { useCallback } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

export type UnitSelectorProps<T> = {
    disabled?: boolean;
    shaded?: boolean;
    selected: string;
    values: Array<Unit.Unit<T>>;
    onChange: (payload: Unit.Unit<T>) => void;
}

export function UnitSelector<T>({
    disabled = false,
    shaded = true,
    selected,
    values,
    onChange,
}: UnitSelectorProps<T>) {
    const options = values.map((value) => value.name);

    const handleChange = useCallback((value: string) => {
        const payload = values.find(({ name }) => name === value);

        if (payload) {
            onChange(payload);
        }
    }, [onChange, values]);

    return (
        <DropdownField
            size="lg"
            renderOption={(label) => <I18n messageId={label}/>}
            disabled={disabled}
            selectedValue={selected}
            options={options}
            shaded={shaded}
            onChange={handleChange}
        />
    );
}
